import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5486_2301)">
      <rect
        width="24"
        height="24"
        rx="4"
        transform="matrix(-1 0 0 1 24.0005 0)"
        fill="#11181C"
      />
      <g filter="url(#filter0_d_5486_2301)">
        <path
          d="M14.3068 14.2056L17.2284 17.0475L15.8579 18.3809L12.9358 15.5396C12.685 15.2955 12.3554 15.1628 11.9997 15.1628C11.6441 15.1628 11.3134 15.2955 11.0632 15.5396L8.14107 18.3809L6.77001 17.0475L9.6921 14.2056H14.3068Z"
          fill="white"
        />
        <path
          d="M18.7842 14.4248L14.794 13.3864L14.7919 13.3843L12.4848 9.49926L13.5529 5.61902L15.4271 6.1061L14.359 9.98688C14.3133 10.1501 14.3014 10.3209 14.3241 10.4888C14.3468 10.6568 14.4036 10.8184 14.4911 10.9637C14.5789 11.1114 14.6952 11.2404 14.8331 11.3433C14.9711 11.4462 15.1281 11.521 15.2951 11.5633L19.2853 12.6022L18.7842 14.4248Z"
          fill="white"
        />
        <path
          d="M9.20704 13.3864L5.21686 14.4248L4.71582 12.6022L8.706 11.5633C8.87305 11.5209 9.03006 11.4461 9.16803 11.3431C9.30599 11.2401 9.42221 11.111 9.51 10.9632C9.59747 10.8178 9.65429 10.6563 9.67699 10.4883C9.6997 10.3204 9.68781 10.1496 9.64205 9.98635L8.57449 6.1061L10.4487 5.61902L11.5168 9.49926L9.2097 13.3843L9.20704 13.3864Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5486_2301"
        x="-18.9775"
        y="-13.3356"
        width="61.956"
        height="60.1485"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.73867" />
        <feGaussianBlur stdDeviation="11.8467" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5486_2301"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5486_2301"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5486_2301">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
